import React from 'react';
// import { createRoot, hydrateRoot } from "react-dom/client";
import ReactDOM from 'react-dom/client';
import App from './App';

import { ThemeProvider } from "styled-components";
import './index.css';

const theme = {
    colors: {
        black: '#282c34',
        light: '#ebebeb',
        white: '#ffffff',
        main: '#BD5D38',
    }
}

const Base = () => <React.StrictMode>
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
</React.StrictMode>

// const rootElement = document.getElementById("root");
// if (rootElement.hasChildNodes()) {
//   hydrateRoot(rootElement, <Base />);
// } else {
//   createRoot(rootElement).render(<Base />);
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Base />);
